// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';

const fragments = {
	IFRAME: '[data-fragment="VideoModal.iframe"]',
};

export default class VideoModal extends WebComponent {

	didMount() {
		const modalId = `#${this.element.getAttribute('id')}`;
		const iframe = this.element.querySelector(fragments.IFRAME);
		$(modalId).on('hide.bs.modal', function (e) {
			iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
		})
		$(modalId).on('shown.bs.modal', function (e) {
			iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
		})
	}

	willUnMount() {}
	update() {

	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources-cvrez/js/components/VideoModal.js